import * as tslib_1 from "tslib";
import { IgrDefinitionBase } from "./igr-definition-base";
import { HeaderRowSeparator } from "./HeaderRowSeparator";
/**
 * Represents a Header Row separator. This is used to visually separate the header row from the rest of the rows in a grid.
*/
var IgrHeaderRowSeparator = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IgrHeaderRowSeparator, _super);
    function IgrHeaderRowSeparator(props) {
        return _super.call(this, props) || this;
    }
    IgrHeaderRowSeparator.prototype.createImplementation = function () {
        return new HeaderRowSeparator();
    };
    Object.defineProperty(IgrHeaderRowSeparator.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    return IgrHeaderRowSeparator;
}(IgrDefinitionBase));
export { IgrHeaderRowSeparator };
//# sourceMappingURL=igr-header-row-separator.js.map
